import cookies from 'js-cookie';

const COOKIE_NAME = 'cookie_consent_allowances';
const GOOGLE_ALLOANCES = 'google_analytics_allowances';
const DELIMINATATOR = ';';

const AllAllowances = {
  Convienences: ['Facebook', 'Youtube', 'Vimeo'],
  Analytics: [
    'Facebook Pixel',
    'Google Analytics',
    'Google Maps',
    'AdAnt Media Werbeerfolgsmessung',
  ],
};

const getPersistedConsentAllowances = () => {
  const strinfifiedAllowances = cookies.get(COOKIE_NAME);

  return strinfifiedAllowances && strinfifiedAllowances.split(DELIMINATATOR);
};

const persistConsentAllowances = ({ allowances, expires }) => {
  const strinfifiedAllowances = allowances.join(DELIMINATATOR);

  cookies.set(COOKIE_NAME, strinfifiedAllowances, { expires: expires });

  if (allowances.includes('Google Analytics')) {
    const googleAllowances = {
      ad_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      analytics_storage: 'granted',
      functionality_storage: 'granted',
      personalization_storage: 'granted',
      security_storage: 'granted',
    };
    const stringifiedGoogleAllowances = Object.entries(googleAllowances)
      .map(([key, value]) => `${key}=${value}`)
      .join(DELIMINATATOR);

    cookies.set(GOOGLE_ALLOANCES, stringifiedGoogleAllowances, {
      expires: expires,
    });
  }
};

const unpersistConsentAllowances = () => {
  cookies.remove(COOKIE_NAME);
  cookies.remove(GOOGLE_ALLOANCES);
};

export {
  getPersistedConsentAllowances,
  persistConsentAllowances,
  unpersistConsentAllowances,
  AllAllowances,
};
